export const PARTICIPATION_FONT_FAMILY =
    '"Inter Display", Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

export const PARTICIPATION_INDIGO = "#4F5BD5";
export const PARTICIPATION_INDIGO_TINT = "#E6E8FA";
export const PARTICIPATION_BODY_TEXT = "#1F2A44";
export const PARTICIPATION_MUTED_TEXT = "#5A6478";
export const PARTICIPATION_MUTED_VALUE = "#A7ADBD";
export const PARTICIPATION_CARD_BORDER = "#E8EBF0";
export const PARTICIPATION_BAR_TRACK = "#EFF0F7";
export const PARTICIPATION_BAR_FILL = "#E4E6F6";
export const PARTICIPATION_BAR_FILL_LEADER = "#DCDFF6";
export const PARTICIPATION_WARNING_BG = "#FDF1C7";
export const PARTICIPATION_WARNING_TEXT = "#9A4A06";
export const PARTICIPATION_ICON_STROKE = "#5B63D3";
export const PARTICIPATION_INDIGO_HOVER = "#3B45B0";
export const PARTICIPATION_INSET_BG = "#F7F8FC";

// Sizes (px). The whole tab scales from here, so a type-scale change is one edit.
export const PARTICIPATION_TEXT_XS = 12; // pills, hints, small notes
export const PARTICIPATION_TEXT_SM = 13; // body text, buttons
export const PARTICIPATION_TEXT_MD = 14; // emphasised labels, header
export const PARTICIPATION_TEXT_LG = 15; // tile labels, question text
export const PARTICIPATION_TITLE_SIZE = 16; // card titles
export const PARTICIPATION_CONTROL_HEIGHT = 36; // buttons, header bar
export const PARTICIPATION_ROW_HEIGHT = 40; // answer bars, attendee input
export const PARTICIPATION_ICON_SIZE = 16;

export const MIN_RESPONDENTS_FOR_PERCENT = 5;

export type ParticipationDataPhase = "none" | "few" | "many";

export const getParticipationDataPhase = (
    respondents: number
): ParticipationDataPhase => {
    if (respondents === 0) return "none";
    if (respondents < MIN_RESPONDENTS_FOR_PERCENT) return "few";
    return "many";
};

export const participationCardSx = {
    backgroundColor: "#FFFFFF",
    border: `1px solid ${PARTICIPATION_CARD_BORDER}`,
    borderRadius: "12px",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "6px",
    textAlign: "center" as const,
    fontFamily: PARTICIPATION_FONT_FAMILY,
    color: PARTICIPATION_BODY_TEXT,
};

export const participationValueSx = (muted: boolean) => ({
    fontSize: 32,
    fontWeight: 700,
    color: muted ? PARTICIPATION_MUTED_VALUE : PARTICIPATION_BODY_TEXT,
});

export const participationIconChipSx = {
    alignSelf: "flex-start",
    width: 34,
    height: 34,
    borderRadius: "8px",
    backgroundColor: "#EEF0FB",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};
